import React, { useEffect } from 'react';
import i18n from '../../../../../../../utils/ChrI18n';
import RsvpInfo from '../../../../templates/rsvpInfo';
import SlotsInfo from '../../../../templates/SlotsInfo';
import RsvpStat from './RsvpStat';
import ChrLink from '../../../../../../generic/Utils/ChrLink';
import CallToAction from '../../../../templates/CallToAction';

const Content = props => {
  const stats = props.stats;
  const rsvpStats = stats?.rsvpStats;

  const hasStatsAttendanceActionContent = () => {
    return (
      stats?.invitedCountStats ||
      rsvpStats?.length > 0 ||
      props.attendanceActions?.length > 0
    );
  };

  useEffect(() => {
    if(props.attendanceActions?.length > 0)
      EventsAnalytics.trackUpdateAttendance(props.id);
    if(stats?.invitedCountStats)
      EventsAnalytics.trackProgramEventStatusAnalytics(props.id);
  }, [props.id]);

  return(
    <>
      {
        props.rsvpInfo && <RsvpInfo header={ i18n.t('feature.meetings.header.rsvp') } { ...props.rsvpInfo } eventId={ props.id }/>
      }
      { props.callToAction && <CallToAction details={ props.callToAction } /> }

      {
        hasStatsAttendanceActionContent() && (
          <div id={ `cjs-program-event-stats-${props.id}` } className='m-t-sm'>
            {
              stats?.invitedCountStats && <div className='mb-2'>
                <ChrLink
                  className={ stats.invitedCountStats.className }
                  id={ stats.invitedCountStats.id }
                  href={ stats.invitedCountStats.url }
                >
                  { `${stats.invitedCountStats.label} (${stats.invitedCountStats.count})` }
                </ChrLink>
              </div>
            }

            {
              rsvpStats?.map((stat, index) => {
                return <RsvpStat key={ index } { ...stat } eventId={ props.id } />
              })
            }

            { props.attendanceActions && props.attendanceActions.map((stat, index) => {
              return <div className='mb-2' key={ index }>
                <ChrLink
                  id={ stat.id }
                  href={ stat.url }
                  data={ stat.data }
                  className={ stat.className }
                >
                  { stat.label }
                </ChrLink>
              </div>
            })}
          </div>
        )
      }

      {
        props.slotsInfo && <div className='b-t'>
          <SlotsInfo slotsInfo={ props.slotsInfo } eventId={ props.id }/>
        </div>
      }
    </>
  );
}

export default Content;